import React from 'react';
import queryString from 'query-string'
import {Switch, Route, Redirect} from "react-router-dom";
import {observer, inject} from "mobx-react";
import {ReactComponent as TopIcon} from "./img/top.svg";
import Content from "./components/Content";
import Search from "./components/Search";
import Auth from "./components/Auth";
import Footer from './Footer/index';
import "./sass/style.scss";
import "./fixes.css";

@inject(stores => ({
        AuthorizationStore: stores.rootStore.Authorization,
        UIStore: stores.rootStore.UI
    })
)

@observer
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showBanner: true
        };
    }

    changeVisibilityBanner = (show) => {
        this.setState({
            showBanner: show
        })

    }

    render() {
        const {classes} = this.props;
        console.log(window.location.pathname)
        if (window.location.pathname === '/lichnyy_kabinet/kak_otpravit_gruz_na_nash_sklad_bez_oformleniya_zakaza_na_dostavku') {
            window.location.replace(window.location.origin + '/lichnyy_kabinet/kak_sozdat_zakaz_na_konsolidatsiyu')
        }
        try {
        return (
            <>
                {
                    window.location.pathname !== '/auth/signin' && this.state.showBanner && 
                    <div className='footer'>
                        <Footer changeVisibilityBanner={this.changeVisibilityBanner}/>
                    </div>
                }
                {
                    window.location.pathname === "/auth/signin" &&
                    <Auth/>
                }
                {
                    (window.location.pathname !== "/auth/signin" && window.location.pathname.toLocaleLowerCase() !== "/search") &&
                    <Content showBanner={this.state.showBanner}/>
                }
                {
                    window.location.pathname.toLocaleLowerCase() === "/search" &&
                    <Search  showBanner={this.state.showBanner}/>
                }
                <a onClick={() => {
                    window.scroll(0, 0)
                }} className="top">
                    <TopIcon/>
                </a>
                
            </>
        )            
        } catch(e) {
            console.log(e)
        }
    }   
}


export default App
